import React from 'react';
import { INVALID_PROMO_LINK_MESSAGE } from '../utils/promoMessages';
import './InvalidPromoLink.css';

const InvalidPromoLink: React.FC = () => {
  return (
    <div className="invalid-promo-link">
      <div className="invalid-promo-link__content">
        <div className="invalid-promo-link__illustration" aria-hidden="true">
          <svg viewBox="0 0 240 200" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="120" cy="178" rx="72" ry="10" fill="#764ba2" opacity="0.15" />
            <circle cx="120" cy="92" r="56" fill="url(#invalidPromoBg)" />
            <circle cx="120" cy="92" r="56" stroke="#fff" strokeWidth="3" opacity="0.45" />
            <path
              d="M78 92h28c8.837 0 16-7.163 16-16s-7.163-16-16-16H78"
              stroke="#fff"
              strokeWidth="9"
              strokeLinecap="round"
            />
            <path
              d="M162 92h-28c-8.837 0-16 7.163-16 16s7.163 16 16 16h28"
              stroke="#fff"
              strokeWidth="9"
              strokeLinecap="round"
              strokeDasharray="8 12"
            />
            <circle cx="120" cy="92" r="18" fill="#fff" opacity="0.95" />
            <path
              d="M112 84l16 16M128 84l-16 16"
              stroke="#e74c3c"
              strokeWidth="4"
              strokeLinecap="round"
            />
            <defs>
              <linearGradient id="invalidPromoBg" x1="64" y1="36" x2="176" y2="148">
                <stop stopColor="#667eea" />
                <stop offset="1" stopColor="#764ba2" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <p className="invalid-promo-link__caption">{INVALID_PROMO_LINK_MESSAGE}</p>
      </div>
    </div>
  );
};

export default InvalidPromoLink;
